import { Icon } from '@nexus/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Frame of the pages without session: login and the pages of the password links. Platform
 * design, no company brand (docs/ui/design-system.md, Theming).
 */
export function PublicFrame({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <header className="flex h-(--topbar-h) items-center gap-2.5 px-4 md:px-6">
        <span
          aria-hidden
          className="flex size-7 items-center justify-center rounded-sm bg-brand-solid text-brand-solid-fg"
        >
          <Icon name="layers" className="size-4" />
        </span>
        <span className="font-semibold text-fg">{t('app.name')}</span>
      </header>

      <main className="flex flex-1 items-start justify-center px-4 pt-[8vh] pb-10 md:items-center md:pt-0">
        <div className="w-full max-w-md">
          <h1 className="text-2xl font-semibold tracking-tight text-fg">{title}</h1>
          {description && <p className="mt-1 text-fg-muted">{description}</p>}
          {children}
        </div>
      </main>

      <footer className="px-4 pb-6 text-center text-xs text-fg-subtle">{t('login.footer')}</footer>
    </div>
  );
}
